import { Component } from "@angular/core";
import { NavController } from "@ionic/angular";

@Component({
    selector: 'team-settings',
    templateUrl: 'team-settings.html',
    styleUrls:['./team-settings.scss']
})

export class TeamSettings {
    counters = [
        {
            name: "Anzahl der Begegnungen",
            value: 0
        },
        {
            name: "Punkte fur den Sieg",
            value: 0
        },
        {
            name: "Punkte fur Unentschieden",
            value: 0
        },
        {
            name: "Punkte fur den Verlust",
            value: 0
        }
    ]

    constructor(private navCtrl: NavController){
        
    }

    onBackMenu(){
        this.navCtrl.pop()
    }
}